import React from 'react';
import { useHits } from 'react-instantsearch';

export default function EstablishmentHits() {
    const { hits } = useHits();

    if (hits.length === 0) return null;

    return (
        <div className="col-12">
            <p className="font-weight-bold mb-6">{window.Translator.trans('app.header.search.results.establishments')}</p>
            <div className="row row--equalized gutters-2 gutters-lg-4">
                {hits.map((establishment, index) => (
                    <div key={index} className="col-4 col-md-3 col-lg-2">
                        <a className="text-decoration-none" href={establishment?.url}>
                            <div className="card bg-white h-100">
                                <div className="card-body p-3 p-lg-6">
                                    <div className="d-flex flex-column gap-5">
                                        <img className="m-auto img-fluid search-brand-logo" src={establishment?.image_url} width="60" alt={establishment?.title}/>
                                        <p className="text-center text--14">{establishment?.title}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}
